import React from "react";
import { IBar, StyledBar } from "./Bar.styled";

const Bar = ({ percent, isUserChoice }: IBar) => {
    return <StyledBar percent={percent} isUserChoice={isUserChoice} />;
};

export default Bar;
